// RequestForm.js

import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  TextField,
  MenuItem,
  Button,
  Typography,
  Select,
  InputLabel,
  FormControl,
  OutlinedInput,
  Checkbox,
  Link,
  ListItemText,
  FormControlLabel,
  IconButton
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import ListboxComponent from '../ListboxComponent';
import { getNames, getCode } from 'country-list';
import currencyCodes from 'currency-codes';
import DeleteIcon from '@mui/icons-material/Delete';
import { getIconByMimeType } from '../../iconMap';
import { SITE_URL } from '../../utils/seo';
// ?????? ??? ??????
const countries = getNames();
const currencies = currencyCodes.codes();
const services = [
  "Email Campaigns",
  "SMS Campaigns",
  "Google Ads",
  "Facebook Ads",
  "VK Ads",
  "SEO"
];
const objectives = [
  "Increase sales", "Attract new customers", "Increase brand awareness",
  "Drive more website traffic", "Generate leads", "Promote a new product or service",
  "Engage the audience", "Promote special offers or discounts",
  "Grow subscribers", "Improve customer retention", "Collect feedback",
  "Improve conversion rates", "Retargeting"
];
const ageRanges = ["18-24", "25-34", "35-44", "45-54", "55-64", "65+"];
const genders = ["Male", "Female", "All"];
const contactDatabases = ["I have my own database", "Use the agency database"];

// ????????? ?????? ????? � ????????? ????? ???? projectName
const initialFormData = {
  firstName: '',
  lastName: '',
  companyName: '',
  phoneNumber: '',
  email: '',
  projectName: '', // ????? ???????????? ????
  chosenService: '',
  serviceSelection: [],
  campaignObjective: '',
  countries: [],
  cities: [],
  ageRange: [],
  gender: '',
  keywords: '',
  approximateBudget: '',
  currency: '',
  targetAudienceDescription: '',
  contactDatabase: '',
  additionalMessage: '',
  graphicService: '',
  graphicDescription: '',
  graphicWebsite1: '',
  graphicWebsite2: '',
  graphicWebsite3: '',
  graphicFiles: [],
  seoWebpage: '',
  seoDescription: '',
  // Web development fields
  webDevMessage: '',
  webDevWebsite1: '',
  webDevWebsite2: '',
  webDevWebsite3: '',
  webDevFiles: [],
  // Complete Business Setup fields
  businessMessage: '',
  businessWebsite1: '',
  businessWebsite2: '',
  businessWebsite3: '',
  businessFiles: [],
  privacyPolicyAgreed: false
};

const RequestForm = ({ onFormSubmit, formRef, onSuccess, onError }) => {
  const [formData, setFormData] = useState(initialFormData);
  const [allCities, setAllCities] = useState([]);
  const formElement = useRef(null);

  useEffect(() => {
    // ???? ???????????? ????????????????, ???????? ?????? ???????
    // ??????????????, ??? API /api/users/me ?????????? ?????? ? ??????? ??????
    fetch('/api/users/me', { credentials: 'include' })
      .then(res => {
        if (!res.ok) throw new Error(`HTTP error ${res.status}`);
        return res.json();
      })
      .then(userData => {
        // ????????? ???? Client Information, ???? ??? ??? ?? ?????????
        setFormData(prev => ({
          ...prev,
          firstName: userData.firstName || prev.firstName,
          lastName: userData.lastName || prev.lastName,
          companyName: userData.company || prev.companyName,
          phoneNumber: userData.phone || prev.phoneNumber,
          email: userData.email || prev.email
        }));
      })
      .catch(err => {
        console.error('Error fetching profile:', err);
      });
  }, []);
  
  // ???????? ?????? ???????
  useEffect(() => {
    fetch('/api/cities')
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
        return response.json();
      })
      .then(data => setAllCities(data))
      .catch(err => {
        console.error('Failed to load city data:', err);
        // Don't show error message on initial load
      });
  }, []);

  const selectedCountryCodes = formData.countries
    .map(name => getCode(name))
    .filter(Boolean);
  const filteredCities = selectedCountryCodes.length > 0
    ? allCities.filter(city => selectedCountryCodes.includes(city.country))
    : [];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleMultiSelectChange = (fieldName) => (event) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: event.target.value
    }));
  };

  const handleAutocompleteChange = (fieldName) => (event, newValue) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: newValue
    }));
  };

  const handleAutocompleteChangeForCities = (event, newValue) => {
    const cityNames = newValue.map(cityObj => cityObj.name);
    setFormData(prev => ({
      ...prev,
      cities: cityNames
    }));
  };

  const handleRemoveFile = (fileArrayName, index) => {
    setFormData(prev => {
      const updatedFiles = [...prev[fileArrayName]];
      updatedFiles.splice(index, 1);
      return { ...prev, [fileArrayName]: updatedFiles };
    });
  };

  // ????? ??????: ????????? ????? ????? ? ??? ???????????? ? ?????????? preview
  const handleFileChange = (fileArrayName) => (e) => {
    const newFiles = Array.from(e.target.files).map(file => ({
      file,
      name: file.name,
      preview: URL.createObjectURL(file)
    }));
    setFormData(prev => ({
      ...prev,
      [fileArrayName]: [...prev[fileArrayName], ...newFiles]
    }));
  };

  // Set form ref when component mounts
  useEffect(() => {
    if (formRef) {
      formRef(formElement.current);
    }
  }, [formRef]);

  const handleSubmit = async (e) => {
    if (e) {
      e.preventDefault();
    }
    
    // Проверка обязательных полей
    if (!formData.firstName || !formData.lastName || !formData.email || !formData.projectName || !formData.chosenService) {
      if (onError) {
        onError('Please fill in all required fields: First Name, Last Name, Email, Project Name, and Chosen Service');
      }
      return;
    }

    if (!formData.privacyPolicyAgreed) {
      if (onError) {
        onError('Please agree to the Privacy Policy');
      }
      return;
    }

    try {
      const formDataToSend = new FormData();
      
      // Добавляем все поля формы, кроме файлов
      const fileArrays = ['graphicFiles', 'webDevFiles', 'businessFiles'];
      Object.entries(formData).forEach(([key, value]) => {
        if (!fileArrays.includes(key)) {
          if (Array.isArray(value)) {
            value.forEach(item => {
              formDataToSend.append(key, item);
            });
          } else {
            formDataToSend.append(key, value);
          }
        }
      });

      // Добавляем файлы
      fileArrays.forEach(fileArrayName => {
        if (formData[fileArrayName].length > 0) {
          formData[fileArrayName].forEach(({ file }) => {
            formDataToSend.append(fileArrayName, file);
          });
        }
      });

      const response = await fetch('/api/requests', {
        method: 'POST',
        body: formDataToSend,
        credentials: 'include'
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to submit request');
      }

      await response.json();
      setFormData(initialFormData); // Сброс формы после успешной отправки
      
      // Вызываем колбэки после успешной отправки
      if (onSuccess) {
        onSuccess('Request submitted successfully!');
      }
      if (onFormSubmit) {
        onFormSubmit();
      }
      
    } catch (error) {
      console.error('Error submitting request:', error);
      if (onError) {
        onError(error.message || 'Failed to submit request. Please try again.');
      }
    }
  };

  return (
  
   <>
    
    <Box>
      <Box sx={{ textAlign: 'center', mb: 3 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 'bold',
            mb: 1
          }}
        >
          Add Projects
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            color: 'gray',
            mx: 'auto',
            maxWidth: 600
          }}
        >
          Comprehensive business growth: Email and SMS campaigns, targeted advertising, SMM, graphic and UX/UI design, SEO, and sales funnel strategy.
        </Typography>
      </Box>
      <Box 
        component="form" 
        ref={formElement}
        onSubmit={handleSubmit}
        noValidate
      >
        {/* Client Information */}
        <Section title="Client Information">
          <TextField name="firstName" label="First name" fullWidth required sx={{ mb: 2 }} onChange={handleChange} value={formData.firstName} />
          <TextField name="lastName" label="Last name" fullWidth required sx={{ mb: 2 }} onChange={handleChange} value={formData.lastName} />
          <TextField name="companyName" label="Company name" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.companyName} />
          <TextField name="phoneNumber" label="Phone number" fullWidth required sx={{ mb: 2 }} onChange={handleChange} value={formData.phoneNumber} />
          <TextField name="email" label="Email address" fullWidth required sx={{ mb: 2 }} onChange={handleChange} value={formData.email} />
        </Section>

        {/* ????? ????: Project Name */}
        <Section title="Project Name">
          <TextField
            name="projectName"
            label="Project Name"
            fullWidth
            required
            sx={{ mb: 2 }}
            onChange={handleChange}
            value={formData.projectName}
            helperText="Enter project name"
          />
        </Section>

        {/* Choose a Service */}
        <Section title="Choose a Service">
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Choose a Service</InputLabel>
            <Select name="chosenService" value={formData.chosenService} onChange={handleChange} label="Choose a Service" >
              <MenuItem value="Digital-marketing">Digital-marketing</MenuItem>
              <MenuItem value="Web & UX/UI & Graphic design">Web & UX/UI & Graphic design</MenuItem>
              <MenuItem value="SEO">SEO</MenuItem>
              <MenuItem value="Web development">Web development</MenuItem>
              <MenuItem value="Complete Business Setup">Complete Business Setup</MenuItem>
            </Select>
          </FormControl>
        </Section>

        {/* ????????? ????? ????? (Digital-marketing, Target Audience, etc.) */}
        {formData.chosenService === "Digital-marketing" && (
          <>
            <Section title="Marketing Service">
              <FormControl fullWidth sx={{ mb: 2 }}>
    <InputLabel>Service Selection</InputLabel>
    <Select
      multiple
      name="serviceSelection"
      value={formData.serviceSelection}
      onChange={handleChange}
      input={<OutlinedInput label="Service Selection" />}
      renderValue={(selected) => selected.join(', ')}
      required
    >
      {services.map((service) => (
        <MenuItem key={service} value={service}>
          <Checkbox checked={formData.serviceSelection.indexOf(service) > -1} />
          <ListItemText primary={service} />
        </MenuItem>
      ))}
    </Select>
  </FormControl>
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>Campaign Objective</InputLabel>
                <Select name="campaignObjective" value={formData.campaignObjective} onChange={handleChange} label="Campaign Objective" >
                  {objectives.map(objective => (
                    <MenuItem key={objective} value={objective}>
                      {objective}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Section>

            <Section title="Target Audience">
              <Autocomplete
                multiple
                options={countries}
                getOptionLabel={(option) => option}
                filterSelectedOptions
                onChange={handleAutocompleteChange('countries')}
                value={formData.countries}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" label="Country(ies)" placeholder="Select countries..." />
                )}
                sx={{ mb: 2, width: '100%' }}
              />
              <Autocomplete
                multiple
                disableListWrap
                options={filteredCities}
                getOptionLabel={(option) => option.name}
                ListboxComponent={ListboxComponent}
                filterSelectedOptions
                onChange={handleAutocompleteChangeForCities}
                value={filteredCities.filter(cityObj => formData.cities.includes(cityObj.name))}
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" label="City(ies)" placeholder={formData.countries.length > 0 ? "Select cities..." : "Select country first"} />
                )}
                sx={{ mb: 2, width: '100%' }}
              />
              <MultiSelectField
                label="Age Range"
                options={ageRanges}
                value={formData.ageRange}
                onChange={handleMultiSelectChange('ageRange')}
              />
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>Gender</InputLabel>
                <Select name="gender" value={formData.gender} onChange={handleChange} label="Gender" >
                  {genders.map(g => (
                    <MenuItem key={g} value={g}>
                      {g}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Section>

            <Section title="Keywords">
              <TextField name="keywords" label="Keywords" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.keywords} />
            </Section>

            <Section title="Campaign Details">
              <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                <TextField name="approximateBudget" label="Approximate Budget" type="number" fullWidth onChange={handleChange} value={formData.approximateBudget} />
                <Autocomplete
                  options={currencies.sort((a, b) => {
                    const favorites = ['EUR', 'USD'];
                    const aFav = favorites.includes(a) ? 0 : 1;
                    const bFav = favorites.includes(b) ? 0 : 1;
                    if (aFav !== bFav) return aFav - bFav;
                    return a.localeCompare(b);
                  })}
                  groupBy={(option) =>
                    ['EUR', 'USD'].includes(option)
                      ? 'Popular'
                      : 'Search for your currency'
                  }
                  getOptionLabel={(option) => option}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" label="Currency" placeholder="Search for your currency" />
                  )}
                  onChange={(event, newValue) =>
                    setFormData(prev => ({ ...prev, currency: newValue }))
                  }
                  value={formData.currency || ''}
                  sx={{ width: '100%' }}
                />
              </Box>
              <TextField name="targetAudienceDescription" label="Target Audience Description" fullWidth multiline rows={4} sx={{ mb: 2 }} onChange={handleChange} value={formData.targetAudienceDescription} />
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>Contact Database</InputLabel>
                <Select name="contactDatabase" value={formData.contactDatabase} onChange={handleChange} label="Contact Database">
                  {contactDatabases.map(db => (
                    <MenuItem key={db} value={db}>
                      {db}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Section>

            <Section title="Additional Information">
              <TextField name="additionalMessage" label="Message" fullWidth multiline rows={4} sx={{ mb: 2 }} onChange={handleChange} value={formData.additionalMessage} />
            </Section>
          </>
        )}

        {formData.chosenService === "Web & UX/UI & Graphic design" && (
          <>
            <Section title="Graphic Service">
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>Graphic Service</InputLabel>
                <Select name="graphicService" value={formData.graphicService} onChange={handleChange} label="Graphic Service" required>
                  <MenuItem value="Web design">Web design</MenuItem>
                  <MenuItem value="UX/UI design">UX/UI design</MenuItem>
                  <MenuItem value="Graphic design">Graphic design</MenuItem>
                </Select>
              </FormControl>
            </Section>

            {formData.graphicService && (
              <Section title="Description">
                <TextField name="graphicDescription" label="Description" fullWidth multiline rows={4} sx={{ mb: 2 }} onChange={handleChange} value={formData.graphicDescription} required />
                {(formData.graphicService === "Web design" ||
                  formData.graphicService === "UX/UI design") && (
                  <>
                    <TextField name="graphicWebsite1" label="Inspiration Website 1" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.graphicWebsite1} />
                    <TextField name="graphicWebsite2" label="Inspiration Website 2" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.graphicWebsite2} />
                    <TextField name="graphicWebsite3" label="Inspiration Website 3" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.graphicWebsite3} />
                  </>
                )}

                <Button variant="outlined" component="label" sx={{ mb: 2 }}>
                  Upload Files
                  <input type="file" hidden multiple onChange={handleFileChange('graphicFiles')} />
                </Button>

                <FileAttachmentList
                  files={formData.graphicFiles}
                  filesKey="graphicFiles"
                  onRemove={handleRemoveFile}
                />
              </Section>
            )}
          </>
        )}

        {formData.chosenService === "SEO" && (
          <Section title="Your Webpage">
            <TextField name="seoWebpage" label="Webpage" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.seoWebpage} required />
            <TextField name="seoDescription" label="Description" fullWidth multiline rows={4} sx={{ mb: 2 }} onChange={handleChange} value={formData.seoDescription} required />
          </Section>
        )}

        {formData.chosenService === "Web development" && (
          <Section title="Web Development Details">
            <TextField name="webDevMessage" label="Message" fullWidth multiline rows={4} sx={{ mb: 2 }} onChange={handleChange} value={formData.webDevMessage} />
            <TextField name="webDevWebsite1" label="Inspiration Website 1" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.webDevWebsite1} />
            <TextField name="webDevWebsite2" label="Inspiration Website 2" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.webDevWebsite2} />
            <TextField name="webDevWebsite3" label="Inspiration Website 3" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.webDevWebsite3} />

            <Button variant="outlined" component="label" sx={{ mb: 2 }}>
              Upload Files
              <input type="file" hidden multiple onChange={handleFileChange('webDevFiles')} />
            </Button>

            <FileAttachmentList
              files={formData.webDevFiles}
              filesKey="webDevFiles"
              onRemove={handleRemoveFile}
            />
          </Section>
        )}

        {formData.chosenService === "Complete Business Setup" && (
          <Section title="Complete Business Setup Details">
            <TextField name="businessMessage" label="Message" fullWidth multiline rows={4} sx={{ mb: 2 }} onChange={handleChange} value={formData.businessMessage} />
            <TextField name="businessWebsite1" label="Inspiration Website 1" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.businessWebsite1} />
            <TextField name="businessWebsite2" label="Inspiration Website 2" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.businessWebsite2} />
            <TextField name="businessWebsite3" label="Inspiration Website 3" fullWidth sx={{ mb: 2 }} onChange={handleChange} value={formData.businessWebsite3} />

            <Button variant="outlined" component="label" sx={{ mb: 2 }}>
              Upload Files
              <input type="file" hidden multiple onChange={handleFileChange('businessFiles')} />
            </Button>

            <FileAttachmentList
              files={formData.businessFiles}
              filesKey="businessFiles"
              onRemove={handleRemoveFile}
            />
          </Section>
        )}

        <Box sx={{ mt: 2 }}>
          <FormControlLabel
            control={
              <Checkbox name="privacyPolicyAgreed" checked={!!formData.privacyPolicyAgreed} onChange={handleChange} required />
            }
            label={
              <Typography sx={{ color: "#969696" }}>
                I confirm that I have read and agree to our&nbsp;
                <Link href={`${SITE_URL}/privacy-policy`} target="_blank" rel="noopener" sx={{ color: "#969696", textDecoration: "underline" }}>
                  Privacy Policy
                </Link>
                <span style={{ color: "red", marginLeft: "4px" }}>Required</span>
              </Typography>
            }
          />
        </Box>

      </Box>
    </Box>
    </>
  );
}

function FileAttachmentList({ files, filesKey, onRemove }) {
  if (!files?.length) return null;
  return (
    <Box mt={2}>
      {files.map((file, index) => (
        <Box
          key={index}
          display="flex"
          alignItems="center"
          border="1px solid #ccc"
          borderRadius="4px"
          p={1}
          mb={1}
        >
          {file.file.type.startsWith('image/') ? (
            <img
              src={file.preview}
              alt="Preview"
              width={50}
              height={50}
              style={{ marginRight: 10 }}
            />
          ) : (
            <Box sx={{ mr: 2 }}>
              {getIconByMimeType(file.file.type)}
            </Box>
          )}
          <Typography variant="body2" sx={{ flexGrow: 1 }}>
            {file.name}
          </Typography>
          <IconButton onClick={() => onRemove(filesKey, index)}>
            <DeleteIcon />
          </IconButton>
        </Box>
      ))}
    </Box>
  );
}

function Section({ title, children }) {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        {title}
      </Typography>
      {children}
    </Box>
  );
}

function MultiSelectField({ label, options, value, onChange }) {
  return (
    <FormControl fullWidth sx={{ mb: 2 }}>
      <InputLabel>{label}</InputLabel>
      <Select
        multiple
        value={value}
        onChange={onChange}
        input={<OutlinedInput label={label} />}
        renderValue={(selected) => selected.join(', ')}
      >
        {options.map(option => (
          <MenuItem key={option} value={option}>
            <Checkbox checked={value.indexOf(option) > -1} />
            <ListItemText primary={option} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default RequestForm;
